import React from 'react';
import { Checkbox } from '../ui/checkbox';

// Reusable selectable option where clicking ANYWHERE (the checkbox OR the label/row)
// toggles the value. Keeps selection UX consistent across the app.
export const CheckboxOption = ({
  checked,
  onChange,
  label,
  disabled = false,
  bordered = true,
  className = '',
  testId,
}) => {
  const handleToggle = () => {
    if (!disabled) onChange(!checked);
  };

  return (
    <div
      role="checkbox"
      aria-checked={!!checked}
      aria-disabled={disabled}
      onClick={handleToggle}
      data-testid={testId}
      className={`flex items-center gap-2 p-2 ${bordered ? 'rounded border' : ''} ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer hover:bg-muted/50'} ${className}`}
    >
      <Checkbox checked={!!checked} disabled={disabled} tabIndex={-1} className="pointer-events-none" />
      <label className={`text-sm ${disabled ? '' : 'cursor-pointer'}`}>{label}</label>
    </div>
  );
};

export default CheckboxOption;
